import { useMemo } from "react";
import { Rule } from "@rebuild/shared";
import { CollapsibleSection } from "../../components/ui/CollapsibleSection";
import { formatAuthor } from "./RuleAuditTrail";
import { Table, TableRecord } from "./Table";

interface DraftRulesTableProps {
  draftRules: Rule[];
  onRuleSelect: (rule: Rule) => void;
}

/**
 * A simplified view of every draft rule. Draft rules are works in progress that the rules engine never runs, so they
 * only need enough context to find and open them again.
 */
export const DraftRulesTable: React.FC<DraftRulesTableProps> = ({ draftRules, onRuleSelect }) => {
  const tableRecords = useMemo(
    (): TableRecord[] =>
      draftRules.map((rule, i) => {
        const createdEvent = rule.auditTrail?.find((event) => event.eventType === "created");
        return {
          Action: (
            <button
              onClick={() => onRuleSelect(rule)}
              className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-1 px-3 rounded text-xs transition-colors"
            >
              Update
            </button>
          ),
          "Rule Name": rule.name,
          "Rule Type": rule.templateId,
          "Created By": createdEvent ? formatAuthor(createdEvent) : "",
          Note: createdEvent?.note ?? "",
          __backgroundColor: i % 2 === 0 ? "#F9F9F9" : "white",
        };
      }),
    [draftRules, onRuleSelect],
  );

  return (
    <CollapsibleSection title="Draft Rules" badge={`${draftRules.length}`}>
      <Table records={tableRecords} />
    </CollapsibleSection>
  );
};
